export default (productCode, value) => ({
  op: 'replace',
  path: `/flowConfig/${productCode}/enabled`,
  value,
});
